//import logo from "./logo.svg";
import "./App.css";
import React from "react";
import MapContainer from "./functions/MapContainer";

function App() {
  return <MapContainer />;
}

export default App;
